export const ADD_PROPERTY_REQUEST = "ADD_PROPERTY_REQUEST"
export const ADD_PROPERTY_SUCCESS = "ADD_PROPERTY_SUCCESS"
export const ADD_PROPERTY_FAIL = "ADD_PROPERTY_FAIL"
export const ADD_PROPERTY_RESET = "ADD_PROPERTY_RESET"

export const GET_APPROVED_PROPERTY_REQUEST = "GET_APPROVED_PROPERTY_REQUEST"
export const GET_APPROVED_PROPERTY_SUCCESS = "GET_APPROVED_PROPERTY_SUCCESS"
export const GET_APPROVED_PROPERTY_FAIL = "GET_APPROVED_PROPERTY_FAIL"
export const GET_APPROVED_PROPERTY_RESET = "GET_APPROVED_PROPERTY_RESET"

export const GET_PROPERTY_ID_REQUEST = "GET_PROPERTY_ID_REQUEST"
export const GET_PROPERTY_ID_SUCCESS = "GET_PROPERTY_ID_SUCCESS"
export const GET_PROPERTY_ID_FAIL = "GET_PROPERTY_ID_FAIL"
export const GET_PROPERTY_ID_RESET = "GET_PROPERTY_ID_RESET"